import Flickity from 'flickity-fade';

export default class Sliders {
  constructor() {
    this.sliders = document.querySelectorAll('.cc-slideshow, .flexslider');

    if (!this.sliders) return;

    this.sliders.forEach(slider => {
      const list = slider.querySelector('ul');
      if (!list) return;

      const parent = list.parentNode;
      if (!parent) return;

      while (list.firstChild) {
        parent.insertBefore(list.firstChild, list);
      }

      parent.removeChild(list);

      this.flkty = new Flickity(slider, {
        pageDots: false,
        autoPlay: 6000,
        imagesLoaded: true,
        wrapAround: true,
        lazyLoad: 2,
        adaptiveHeight: true,
      });
    });
  }
}
